/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Button } from "@mui/material";
import { Link } from "react-router";
import DialogModal from "../../../DialogModal/DialogModal";
import Typography from "@mui/material/Typography";

type RecordingConsentPrivacyModalProps = {
  open: boolean;
  onClose: () => void;
};

const RecordingConsentPrivacyModal = ({ open, onClose, ...rest }: RecordingConsentPrivacyModalProps) => {
  return (
    <DialogModal
      open={open}
      onClose={onClose}
      {...rest}
      title={"Datenschutzhinweise zur Gesprächsaufzeichnung"}
      actions={
        <Button fullWidth={true} variant={"contained"} onClick={onClose}>
          Schließen
        </Button>
      }
    >
      <Typography>
        Ihr Vertrauen ist uns wichtig. Deshalb zeichnen wir Ihre Gespräche nur mit Ihrer <strong>freiwilligen</strong> Zustimmung auf. Die Aufzeichnung ist
        kostenlos und dient einzig der Erstellung Ihrer Zusammenfassung. Spätestens 14 Tagen nach dem Gespräch wird die Aufnahme automatisch wieder gelöscht.
      </Typography>
      <Typography>
        Weitere Informationen zu Ihren Datenschutzrechten und der Verarbeitung Ihrer Daten finden Sie in unserer{" "}
        <Link to={"/datenschutz"} target={"_blank"}>
          Datenschutzerklärung
        </Link>
        .
      </Typography>
    </DialogModal>
  );
};

export default RecordingConsentPrivacyModal;
